export default __webpack_public_path__ + "static/media/faceD.bdc635db.png";